import { useMemo } from 'react';

import { filterBySubregion, type SubregionFilter } from './subregion-filter';
import type { WorkshopChip } from './workshopsCalendarTypes';

/**
 * The sub-regions a page's workshops span and the workshops left once the
 * hidden ones are taken out. The page draws the filter controls from
 * `subregions` and hands `shown` to whatever lists them.
 */
export function useSubregionFilter(workshops: WorkshopChip[], hidden: string[]): SubregionFilter {
  return useMemo(() => filterBySubregion(workshops, hidden), [workshops, hidden]);
}
